var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path=== `/${_vm.path}`)?_c('header',{staticClass:"msg-header layout-header"},[_c('van-nav-bar',{attrs:{"title":_vm.text},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('img',{attrs:{"src":"/shopLogo.png","alt":"","id":"msg-header-img"}})]},proxy:true}],null,false,1055978488)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }